import { CreateBase, Form, useTranslate, type MutationMode } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";
import { useIsMobile } from "@/hooks/use-mobile";

import { MobileFormToolbar, MobilePage } from "../layout/MobilePage";
import { ContactInputs } from "./ContactInputs";
import { FormToolbar } from "../layout/FormToolbar";

export const ContactCreate = ({
  mutationMode,
}: {
  mutationMode?: MutationMode;
}) => {
  const isMobile = useIsMobile();
  return (
    <CreateBase redirect="show" mutationMode={mutationMode}>
      {isMobile ? <ContactCreateMobile /> : <ContactCreateDesktop />}
    </CreateBase>
  );
};

const ContactCreateDesktop = () => (
  <div className="mt-2 flex lg:mr-72">
    <div className="flex-1">
      <Form>
        <Card>
          <CardContent>
            <ContactInputs />
            <FormToolbar />
          </CardContent>
        </Card>
      </Form>
    </div>
  </div>
);

const ContactCreateMobile = () => {
  const translate = useTranslate();
  return (
    <MobilePage
      title={translate("resources.contacts.action.new")}
      backTo="/contacts"
    >
      <Form className="flex flex-col gap-4">
        <ContactInputs />
        <MobileFormToolbar />
      </Form>
    </MobilePage>
  );
};
